import {
  EnvConfig,
} from "../config/index";

export const openBreakoutUrl = (
  url,
  successUrl,
  failureUrl
) => {

  if (!url) {
    return;
  }

  window.location = getBreakoutUrl(
    url,
    successUrl,
    failureUrl
  );
};

export const getBreakoutUrl = (
  url,
  successUrl,
  failureUrl
) => {

  if (!url) {
    return '';
  }

  let redirectUrl = `${EnvConfig.miniAppUrl}?url=${window.encodeURIComponent(url)}`;

  if (successUrl) {
    redirectUrl+= `&successUrl=${window.encodeURIComponent(successUrl)}`;
  }

  if (failureUrl) {
    redirectUrl+= `&failureUrl=${window.encodeURIComponent(failureUrl)}`;
  }

  return `${redirectUrl}#/browser`;
};
